import React, { Component } from 'react';
import Wrapper              from './../components/Wrapper';
import Banner               from '../components/containers/BannerContainer';
import PlaceStrap           from './../containers/PlaceStrapContainer';
import PlaceMap             from './../containers/PlaceMapContainer';
import Footer               from '../components/containers/FooterContainer';

import './../css/Place.css';
import './../css/PlaceList.css';

class Places extends Component {
    render() {
        return (
            <div>
                <Banner />
                <PlaceStrap showIcons="map" />
                <Wrapper outerClass="body">
                    <PlaceMap placeId={ this.props.params.id } />
                </Wrapper>
                <Wrapper outerClass="footer">
                    <Footer />
                </Wrapper>
            </div>
        );
    }
}

export default Places;


// WEBPACK FOOTER //
// ./src/pages/PlaceMap.js